import { render, staticRenderFns } from "./TableInspectMerge.vue?vue&type=template&id=795dc0ce&scoped=true"
import script from "./TableInspectMerge.vue?vue&type=script&lang=js"
export * from "./TableInspectMerge.vue?vue&type=script&lang=js"
import style0 from "./TableInspectMerge.vue?vue&type=style&index=0&id=795dc0ce&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "795dc0ce",
  null
  
)

export default component.exports